export default function Footer() {
    return (
        <div className="mt-auto bg-gray-700 flex justify-center items-center h-8 lg:h-16 flex-grow-0 flex-shrink-0 ">
            <span className="text-xs text-white">Copyright © 2021 台灣公車 e 點通 &amp; Z.M. All rights reserved.</span>
        </div>
    )
}